import axios from 'axios'

import { API_URL } from '../Api/index'

const apiClient = axios.create({
  baseURL: API_URL,
  responseType: 'json',
})

export default apiClient



// WEBPACK FOOTER //
// ./src/lib/api-client.js